<template>
    <v-dialog v-model="dialog">
        <v-card>
            <v-app-bar  flat color="transparent">
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="title">
                    Importar XML
                </v-toolbar-title>
            </v-app-bar>

            <v-container> </v-container>

            <v-card-title class="text-h5">
                Selecione o arquivo XML para importação
            </v-card-title>

            <v-file-input
                v-model="file"
                label="Selecione o arquivo XML"
                prepend-icon="mdi-xml"
                variant="filled"
                class="pa-4"
                accept=".xml"
                @change="handleFileUpload(file, $event)"
            ></v-file-input>

            <v-card-actions>
                <v-btn
                    color="error"
                    @click="$emit('close')"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="handleConfirm"
                    :disabled="!file"
                >
                    Importar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'RecebimentoDeNotaFiscalImportXmlView',
    props: ['open'],
    data() {
        return {
            dialog: false,
            file: null,
            items: [],
            codNf: '',
            chaveAcesso: '',
            numPedido: '',
            serie: '',
            nfDateEmissao: '',
            nfDataSaiEnt: '',
            natOp: '',
            emit_cnpj: '',
            emit_razao: '',
            dest_cnpj: '',
            dest_razao: '',
            // Transporte / informações adicionais
            modFrete: '',
            inf_Adic: '',
            qtd_Volumes: '',
            tipo_Volume: '',
            peso_KG: '',
            nfTotals: {
                vProd: 0,
                vNF: 0,
                vFrete: 0,
                vSeg: 0,
                vDesc: 0,
                vIPI: 0,
                vPIS: 0,
                vCOFINS: 0,
                vOutro: 0,
                vIBS: 0,
                vCBS: 0,
            },
            icmsTypes: ["ICMS00", "ICMS10", "ICMS20", "ICMS40", "ICMS51", "ICMS60", "ICMS70", "ICMS90"]
        };
    },
    watch: {
        open(newVal) {
            this.file = null;
            this.dialog = newVal;
        }
    },
    methods: {
        handleFileUpload(event) {
            console.log('File selected:', event);
            const file = event;
            const reader = new FileReader();

            reader.onload = (e) => {
                const xmlContent = e.target.result;
                this.parseXML(xmlContent);
            };

            reader.readAsText(file);
        },

        handleConfirm(){
            this.file = null;
            this.$emit(
                'confirm',
                this.items,
                this.codNf,
                this.chaveAcesso,
                this.numPedido,
                this.serie,
                this.nfDataSaiEnt,
                this.nfTotals,
                this.natOp,
                this.emit_cnpj,
                this.emit_razao,
                this.dest_cnpj,
                this.dest_razao,
                this.modFrete,
                this.inf_Adic,
                this.qtd_Volumes,
                this.tipo_Volume,
                this.peso_KG
            );
        },

        parseXML(xmlStr) {
            this.items = [];
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlStr, "application/xml");

            // Exemplo: pegar o valor de uma tag <nNF>
            const detTags = xmlDoc.getElementsByTagName("det");
            this.codNf = xmlDoc.getElementsByTagName("nNF")[0]?.textContent || '';
            this.chaveAcesso = xmlDoc.getElementsByTagName("chNFe")[0]?.textContent || '';
            this.numPedido = xmlDoc.getElementsByTagName("xPed")[0]?.textContent || '';
            this.serie = xmlDoc.getElementsByTagName("serie")[0]?.textContent || '';
            this.nfDataSaiEnt = xmlDoc.getElementsByTagName("dhSaiEnt")[0]?.textContent || '';
            this.nfDateEmissao = xmlDoc.getElementsByTagName("dhEmi")[0]?.textContent || '';

            // Dados adicionais da NF
            this.natOp = xmlDoc.getElementsByTagName("natOp")[0]?.textContent || '';

            const emit = xmlDoc.getElementsByTagName("emit")[0];
            if (emit) {
                this.emit_cnpj = emit.getElementsByTagName("CNPJ")[0]?.textContent || '';
                this.emit_razao = emit.getElementsByTagName("xNome")[0]?.textContent || '';
            }

            const dest = xmlDoc.getElementsByTagName("dest")[0];
            if (dest) {
                this.dest_cnpj = dest.getElementsByTagName("CNPJ")[0]?.textContent || '';
                this.dest_razao = dest.getElementsByTagName("xNome")[0]?.textContent || '';
            }

            // Transporte
            const transp = xmlDoc.getElementsByTagName("transp")[0];
            if (transp) {
                this.modFrete = transp.getElementsByTagName("modFrete")[0]?.textContent || '';

                const vol = transp.getElementsByTagName("vol")[0];
                if (vol) {
                    this.qtd_Volumes = vol.getElementsByTagName("qVol")[0]?.textContent || '';
                    this.tipo_Volume = vol.getElementsByTagName("esp")[0]?.textContent || '';

                    const pesoB = vol.getElementsByTagName("pesoB")[0]?.textContent || '';
                    const pesoL = vol.getElementsByTagName("pesoL")[0]?.textContent || '';
                    this.peso_KG = pesoB || pesoL || '';
                }
            }

            // Informações adicionais (Fisco + Complementar)
            const infAdic = xmlDoc.getElementsByTagName("infAdic")[0];
            if (infAdic) {
                const infAdFisco = infAdic.getElementsByTagName("infAdFisco")[0]?.textContent || '';
                const infCpl = infAdic.getElementsByTagName("infCpl")[0]?.textContent || '';
                this.inf_Adic = [infAdFisco, infCpl].filter(Boolean).join(' - ');
            }

            // Totais da NF (bloco <total>)
            const icmsTot = xmlDoc.getElementsByTagName("ICMSTot")[0];
            const ibsCbsTot = xmlDoc.getElementsByTagName("IBSCBSTot")[0];

            this.nfTotals = {
                vProd: Number(icmsTot?.getElementsByTagName("vProd")[0]?.textContent ?? 0),
                vNF: Number(icmsTot?.getElementsByTagName("vNF")[0]?.textContent ?? 0),
                vFrete: Number(icmsTot?.getElementsByTagName("vFrete")[0]?.textContent ?? 0),
                vSeg: Number(icmsTot?.getElementsByTagName("vSeg")[0]?.textContent ?? 0),
                vDesc: Number(icmsTot?.getElementsByTagName("vDesc")[0]?.textContent ?? 0),
                vIPI: Number(icmsTot?.getElementsByTagName("vIPI")[0]?.textContent ?? 0),
                vPIS: Number(icmsTot?.getElementsByTagName("vPIS")[0]?.textContent ?? 0),
                vCOFINS: Number(icmsTot?.getElementsByTagName("vCOFINS")[0]?.textContent ?? 0),
                vOutro: Number(icmsTot?.getElementsByTagName("vOutro")[0]?.textContent ?? 0),
                vIBS: Number(ibsCbsTot?.getElementsByTagName("vIBS")[0]?.textContent ?? 0),
                vCBS: Number(ibsCbsTot?.getElementsByTagName("vCBS")[0]?.textContent ?? 0),
            };

            const xPeds = [];

            for (let i = 0; i < detTags.length; i++) {
                const det = detTags[i];
                const prod = det.getElementsByTagName("prod")[0];

                const impostos = det.getElementsByTagName("imposto")[0];
                const ipi = impostos.getElementsByTagName("IPI")[0]?.getElementsByTagName("IPITrib")[0];
                const pis = impostos.getElementsByTagName("PIS")[0]?.getElementsByTagName("PISAliq")[0];
                const cofins = impostos.getElementsByTagName("COFINS")[0]?.getElementsByTagName("COFINSAliq")[0];

                // ICMS genérico: pega o primeiro filho de <ICMS>, seja ICMS00, ICMS60, etc.
                let icmsValue = null;
                const icmsRoot = impostos.getElementsByTagName("ICMS")[0];
                if (icmsRoot) {
                    const children = icmsRoot.children || icmsRoot.getElementsByTagName("*");
                    if (children && children.length > 0) {
                        icmsValue = children[0];
                    }
                }

                // Mapeia campos de base / alíquota / valor, caindo em ST quando não houver os padrões
                const icmsBaseNode = icmsValue?.getElementsByTagName("vBC")[0]
                    || icmsValue?.getElementsByTagName("vBCSTRet")[0];
                const icmsPercNode = icmsValue?.getElementsByTagName("pICMS")[0]
                    || icmsValue?.getElementsByTagName("pST")[0];
                const icmsValorNode = icmsValue?.getElementsByTagName("vICMS")[0]
                    || icmsValue?.getElementsByTagName("vICMSSTRet")[0]
                    || icmsValue?.getElementsByTagName("vICMSSubstituto")[0];

                // IBS / CBS (IBSCBS)
                const ibscbs = impostos.getElementsByTagName("IBSCBS")[0];
                let ibsValor = 0;
                let cbsValor = 0;

                if (ibscbs) {
                    const gIBSCBS = ibscbs.getElementsByTagName("gIBSCBS")[0];
                    if (gIBSCBS) {
                        const vIBSNode = gIBSCBS.getElementsByTagName("vIBS")[0];
                        const gCBSNode = gIBSCBS.getElementsByTagName("gCBS")[0];
                        const vCBSNode = gCBSNode && gCBSNode.getElementsByTagName("vCBS")[0];

                        ibsValor = Number(vIBSNode?.textContent ?? 0);
                        cbsValor = Number(vCBSNode?.textContent ?? 0);
                    }
                }

                console.log('detTags >>> ', det.getElementsByTagName("nItemPed")[0].textContent)

                const xPedValue = prod?.getElementsByTagName("xPed")[0]?.textContent;
                if (xPedValue) xPeds.push(xPedValue);

                this.items.push({
                    _id: Math.random().toString(36).substring(2, 8),
                    status: 'Pendente',
                    seqitem: det.getAttribute("nItem"),
                    descriptionItem: prod?.getElementsByTagName("xProd")[0]?.textContent,
                    qty: parseFloat(prod?.getElementsByTagName("qCom")[0]?.textContent),
                    //qtyReceived: parseFloat(prod?.getElementsByTagName("qCom")[0]?.textContent),
                    vlrunit: Number(prod?.getElementsByTagName("vUnCom")[0]?.textContent ?? 0),
                    vlrtotal: Number(prod?.getElementsByTagName("vProd")[0]?.textContent ?? 0),
                    seqItemPurchaseOrder: det.getElementsByTagName("nItemPed")[0]?.textContent,
                    codPurchaseOrder: prod?.getElementsByTagName("cProd")[0]?.textContent,
                    nfIndustrializacao: prod?.getElementsByTagName("nNF")[0]?.textContent,

                    icmsValorBaseCalculo: Number(icmsBaseNode?.textContent ?? 0),
                    iCMSPercICMS: Number(icmsPercNode?.textContent ?? 0),
                    iCMSVlrICMS: Number(icmsValorNode?.textContent ?? 0),

                    ipiValorBaseCalculo: Number(ipi?.getElementsByTagName("vBC")[0]?.textContent ?? 0),
                    iPIPercIPI: Number(ipi?.getElementsByTagName("pIPI")[0]?.textContent ?? 0),
                    iPIVlrIPI: Number(ipi?.getElementsByTagName("vIPI")[0]?.textContent ?? 0),

                    pISBaseCalculo: Number(pis?.getElementsByTagName("vBC")[0]?.textContent ?? 0),
                    pISPerc: Number(pis?.getElementsByTagName("pPIS")[0]?.textContent ?? 0),
                    pISVlrPIS: Number(pis?.getElementsByTagName("vPIS")[0]?.textContent ?? 0),

                    cofinsBaseCalculo: Number(cofins?.getElementsByTagName("vBC")[0]?.textContent ?? 0),
                    cOFINSPerc: Number(cofins?.getElementsByTagName("pCOFINS")[0]?.textContent ?? 0),
                    cOFINSVlrCOFINS: Number(cofins?.getElementsByTagName("vCOFINS")[0]?.textContent ?? 0),

                    IBSValor: ibsValor,
                    CBSValor: cbsValor,

                    unidadeSigla: prod.getElementsByTagName("uCom")[0]?.textContent,
                    ncm: prod.getElementsByTagName("NCM")[0]?.textContent,
                    cfop: prod.getElementsByTagName("CFOP")[0]?.textContent,
                    dataEmissao: this.nfDateEmissao,
                })

            }

            console.log('ITEMS >>> ', this.items)
            
            const allEqual = xPeds.every(val => val === xPeds[0]);
            if(!allEqual){
                Vue.prototype.$notify({
                    title: "Não permitido xml com pedidos de compra diferentes.",
                    closeOnClick: true,
                    duration: 3000,
                    positions: "right",
                    type: "error",
                });

                this.file = null;
                this.items = []
            }
        }
    }
}
</script>